if(!window.treeFinishMenuInstalled){
 window.treeFinishMenuInstalled=true;
 document.addEventListener('click',event=>{
  const close=event.target.closest('[data-close-finishes]');
  if(close){const branch=close.closest('details');branch.open=false;branch.querySelector('summary')?.focus();}
  const browse=event.target.closest('[data-browse-finishes]');
  if(browse){
   const header=document.querySelector('tree-navigation');if(!header)return;
   const mobile=matchMedia('(max-width:1000px)').matches||header.classList.contains('is-compact');
   if(mobile){const drawer=header.querySelector('[data-nav-drawer]');if(drawer)drawer.open=true;}
   const branch=header.querySelector(`${mobile?'.tc-navigation__drawer-panel':'.tc-navigation__desktop'} .tc-finish-branch`);
   if(branch){branch.open=true;branch.querySelector('summary')?.focus();}
  }
  const pause=event.target.closest('.tc-ticker-pause');
  if(pause){const ticker=pause.closest('.tc-ticker'),paused=ticker.classList.toggle('is-paused');pause.setAttribute('aria-pressed',String(paused));pause.setAttribute('aria-label',paused?'Resume announcements':'Pause announcements');pause.firstElementChild.textContent=paused?'▶':'Ⅱ';}
 });
}
